import styles from "./video.module.css";

function Video({ video }) {
  return (
    <iframe
      className={styles.video}
      src={video}
      allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
}

export default Video;
